import { render, staticRenderFns } from "./MonRekapAlokasi.vue?vue&type=template&id=3de84bb3"
import script from "./MonRekapAlokasi.vue?vue&type=script&lang=js"
export * from "./MonRekapAlokasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports